import {SetGetListGameFreespin} from './thunk/setGetListGameFreespin';
import {SetGetViewGameFreespin} from './thunk/setGetViewGameFreespin';
import {SetPostCreateGameFreespin} from './thunk/setPostCreateGameFreespin';
import {SetPostResultDenomination} from './thunk/setPostResultDenomination';
import {SetPostUpdateGameFreespin} from './thunk/setPostUpdateGameFreespin';
import {SetPostUpdateStatus} from './thunk/setPostUpdateStatus';

export const Thunks = {
    SetGetListGameFreespin,
    SetGetViewGameFreespin,
    SetPostCreateGameFreespin,
    SetPostResultDenomination,
    SetPostUpdateGameFreespin,
    SetPostUpdateStatus
}